<template>
  <div style="display:flex; flex-direction: column;" >
    <v-sheet class="mb-4 pt-2 pb-2" color="white;"  v-if="!isMobile && $route.meta.showHeader">
      <v-container :style="isFullWidth?'':'max-width:1500px; width:80%;'">
        <portal-target name="header-content"></portal-target>
      </v-container>
    </v-sheet>
    <v-container fluid class="pa-4" :style="isFullWidth?'':'max-width:1200px; padding-top:0; min-height:75vh'">
      <slot></slot>
    </v-container>
    <v-footer color="transparent" class="mt-4" >
      <v-container :style="isFullWidth?'':'max-width:1200px;'">
        <portal-target name="footer-content"></portal-target>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "Page",

  props: {
    isFullWidth: {type: Boolean, default: null, required: false}
  },
  computed:{
    ...mapGetters([
        'isMobile'
    ])
  }
}
</script>

<style scoped>

</style>
